export const routes = {
  login: '/',
  loginCallback: '/login-callback',
  dashboard: '/dashboard',
  users: '/users',
  userDetails: '/users/:id/:tab?/:statementId?',
  loans: '/loans',
  loanDetails: '/loans/:id/:tab?/:statementId?',
  cards: '/cards',
  cardDetails: '/cards/:id/:tab?',
  devices: '/devices',
  loanData: '/loan-data',
  notFound: '*',
} as const;
